import React from "react";
import DragDropEditor from "../components/TemplateEditor.js";

function App() {
  return (
    <div>
      <DragDropEditor />
    </div>
  );
}

export default App;
